// extracted by mini-css-extract-plugin
export var container = "_71-0";
export var fallback = "_71-5";
export var fallbackIcon = "_71-6";
export var hidden = "_71-2";
export var image = "_71-3";
export var loaded = "_71-4";
export var placeholder = "_71-1";